
import Shimmer from "@/components/ui/shimmer";

interface Exercise {
  id: string;
  name: string;
  sets: number;
  reps: number;
  weight: number;
  set_data?: any[];
}

interface Routine {
  id: string;
  name: string;
  exercises: Exercise[];
}

interface PlanRoutinesListProps {
  routines: Routine[];
  isLoadingRoutines: boolean;
  error?: Error;
  isPersonalPlan?: boolean;
}

export const PlanRoutinesList = ({ 
  routines, 
  isLoadingRoutines, 
  error, 
  isPersonalPlan 
}: PlanRoutinesListProps) => {
  console.log("PlanRoutinesList - Received routines:", routines);
  console.log("PlanRoutinesList - isPersonalPlan:", isPersonalPlan);

  if (isLoadingRoutines) {
    return (
      <div className="space-y-4">
        {[...Array(2)].map((_, i) => (
          <div key={i} className="border border-clubbers-violet/20 rounded-lg p-4 transition-all duration-300">
            <Shimmer className="h-6 w-48 mb-3" />
            <div className="space-y-3">
              {[...Array(2)].map((_, j) => (
                <Shimmer key={j} className="h-16 w-full rounded-lg" />
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <p className="text-center text-destructive">
        Error al cargar las rutinas: {error.message}
      </p>
    );
  }

  if (!routines?.length) {
    return (
      <p className="text-center text-muted-foreground transition-colors duration-300">
        {isPersonalPlan 
          ? "No has agregado rutinas a tu plan personal todavía"
          : "Este plan aún no tiene rutinas configuradas"}
      </p>
    );
  }

  return (
    <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2 bg-transparent rounded-md">
      {routines.map((routine) => {
        console.log("Rendering routine:", routine);
        return (
          <div key={routine.id} className="border border-border rounded-lg p-4 bg-muted/50 transition-all duration-300 hover:bg-muted">
            <h4 className="font-bold mb-3 text-lg text-primary">{routine.name}</h4>
            <div className="space-y-2">
              {routine.exercises?.map((exercise) => (
                <div 
                  key={exercise.id} 
                  className="rounded-lg p-3 bg-secondary/50 transition-colors border border-border hover:bg-secondary"
                >
                  <p className="font-medium text-sm text-primary">{exercise.name}</p>
                  <p className="text-sm text-muted-foreground">
                    {exercise.sets} series x {exercise.reps} repeticiones
                    {exercise.weight > 0 && ` - ${exercise.weight}kg`}
                  </p>
                  {exercise.set_data && exercise.set_data.length > 0 && (
                    <div className="mt-2 text-xs text-muted-foreground">
                      <p>Últimos registros:</p>
                      <div className="grid grid-cols-3 gap-1 mt-1">
                        {exercise.set_data.slice(0, 3).map((set: any, index: number) => (
                          <span key={index} className="text-foreground/80">
                            {set.weight}kg x {set.reps}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};
